import { OnsiteSearchTextResources } from './onsite-search-configuration';

export const OnsiteSearchDefaultTextResources: OnsiteSearchTextResources = {
  results: {
    showMoreResults: 'show more',
    showMoreResultsClose: 'weniger anzeigen',
    totalResult: 'result',
    totalResults: 'results',
    product: {
      headline: 'Produkte',
    },
    service: {
      headline: 'Service',
    },
    inspiration: {
      headline: 'Inspiration',
    },
    page: {
      headline: 'Weitere',
    },
    category: {
      headline: 'Kategorien',
      preposition: 'in',
    },
  },
  suggestions: {
    headline: 'Suggestions',
    headlineTops: 'Others searched for...',
  },
  alternatives: {
    headline: 'alternative products',
  },
  loading: {
    text: 'please hold the line',
  },
  messages: {
    notFound: {
      headline: 'no results found for: "{{query}}"',
      text: 'there are no matching results',
      notice: '',
    },
    responseError: {
      headline: 'server error',
      text: 'please try again later',
      retryBtn: 'retry',
    },
  },
};
